<template>
  <div>
    <!-- Preview Modal -->
    <div
      v-if="showPreview"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div class="w-11/12 max-w-4xl p-6 bg-white rounded-lg shadow-lg">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-bold">Document Preview</h2>
          <button @click="closePreview" class="text-gray-500 hover:text-gray-700">
            <svg
              class="w-5 h-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <iframe
          :src="previewUrl"
          class="w-full h-[500px] border rounded-md"
          title="Document Preview"
        ></iframe>
        <div class="flex justify-end gap-4 mt-4">
          <button
            @click="closePreview"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            @click="downloadPDF"
            class="px-4 py-2 text-sm font-medium text-white bg-orange-400 rounded-lg hover:bg-orange-500"
          >
            Download
          </button>
          <button
            @click="printPDF"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600"
          >
            Print
          </button>
        </div>
      </div>
    </div>

    <!-- Existing Table -->
    <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div
        class="w-12 h-12 border-b-2 rounded-full animate-spin border-custom-yellow"
      ></div>
    </div>
    <template v-else>
      <div class="relative mt-5 overflow-x-auto shadow-md sm:rounded-lg">
        <table class="w-full text-left text-gray-700 rtl:text-right">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4"></th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Facility
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Units Send
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Issued By
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Date Issued
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(unit) in filteredUnitTransfers"
              :key="unit.unit_transfer_id"
            >
              <!-- Main Row -->
              <tr class="border-b">
                <td class="w-4 p-4">
                  <button
                    @click="toggleExpand(unit.unit_transfer_id)"
                    class="flex items-center text-sm font-semibold text-blue-600 hover:underline"
                  >
                    <svg
                      :class="{
                        'rotate-180 text-indigo-600':
                          expandedTransferId === unit.unit_transfer_id,
                        'text-gray-900':
                          expandedTransferId !== unit.unit_transfer_id,
                      }"
                      class="w-5 h-5 transition-transform duration-300"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.5 8.25L12.4142 12.3358C11.7475 13.0025 11.4142 13.3358 11 13.3358C10.5858 13.3358 10.2525 13.0025 9.58579 12.3358L5.5 8.25"
                        stroke="currentColor"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </td>
                <td class="px-6 py-2">{{ unit.facility }}</td>
                <td class="px-6 py-2">{{ unit.unit_count }}</td>
                <td class="px-6 py-2">
                  {{ unit.user?.first_name }} {{ unit.user?.last_name }}
                </td>
                <td class="px-6 py-2">
                  {{ new Date(unit.issued_date).toLocaleString() }}
                </td>
                <td class="flex items-center px-6 py-2">
                  <button
                    @click="previewPDF(unit.unit_transfer_id)"
                    class="flex items-center p-2 text-sm font-semibold text-white bg-orange-400 rounded-md hover:text-gray-700"
                  >
                    Download
                  </button>
                </td>
              </tr>

              <!-- Expanded Products Row -->
              <tr v-if="expandedTransferId === unit.unit_transfer_id">
                <td colspan="6">
                  <div
                    class="p-4 m-3 border-l-4 border-orange-200 rounded-md bg-gray-50"
                  >
                    <h3 class="font-semibold text-gray-700 text-md">
                      Transfer Products
                    </h3>
                    <table class="w-full mt-2 text-left">
                      <thead>
                        <tr class="bg-gray-200">
                          <th class="px-4 py-2">Pint Serial</th>
                          <th class="px-4 py-2">Volume (ml)</th>
                          <th class="px-4 py-2">Blood Group</th>
                          <th class="px-4 py-2">Product Type</th>
                          <th class="px-4 py-2">Expiry Date</th>
                          <th class="px-4 py-2">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="product in unit.unit_transfer_products"
                          :key="product.unit_transfer_product_id"
                          class="border-t"
                        >
                          <td class="px-4 py-2">
                            {{ product.product.pint_serial }}
                          </td>
                          <td class="px-4 py-2">
                            {{ product.product.volume }}
                          </td>
                          <td class="px-4 py-2">
                            {{ product.product.blood_group.name }}
                          </td>
                          <td class="px-4 py-2">
                            {{ product.product.unit_product.name }}
                          </td>
                          <td class="px-4 py-2">
                            {{
                              new Date(
                                product.product.expiry_date
                              ).toLocaleDateString()
                            }}
                          </td>
                          <td class="px-4 py-2">
                            <span
                              class="px-2 py-2 font-semibold text-gray-700 bg-gray-100 rounded"
                            >
                              {{ product.status }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <p class="mb-2 text-center text-gray-600">{{ showingText }}</p>
      <div class="flex justify-center gap-4 mt-4">
        <button
          @click="previousPage"
          :disabled="currentPage === 1"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m15 19-7-7 7-7"
            />
          </svg>
          Previous
        </button>

        <div class="flex items-center gap-2">
          <button
            v-for="page in visiblePages"
            :key="page"
            @click="goToPage(page)"
            :class="{
              'bg-custom-blue text-white': page === currentPage,
              'text-custom-blue': page !== currentPage,
            }"
            class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
          >
            <span
              class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
            >
              {{ page }}
            </span>
          </button>
        </div>

        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          Next
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m9 5 7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/services/api";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

export default {
  name: "ExternalUnitIssuanceTab",
  components: {},
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
  return {
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    perPage: 10,
    loading: false,
    donations: [],
    products: [],
    error: null,
    filters: {
      facility: "",
      dateIssued: "",
    },
    facility_details: "",
    expandedTransferId: null,
    showPreview: false,
    previewUrl: null,
    pdfDoc: null,
    currentUnitTransferId: null,
  };
},
  mounted() {
    this.user = this.$store.getters["auth/user"];
    this.facility_logo = this.user.user_roles[0]?.facility_department?.facility?.logo;
    this.facility_details = this.user.user_roles[0]?.facility_department?.facility;
    this.getUnitTransfers();
  },
  computed: {
    visiblePages() {
      return this.calculatePageRange();
    },
    filteredUnitTransfers() {
      const search = this.searchQuery.toLowerCase();
      return this.products.filter((product) => {
        const facility = product.facility || "";
        const issuedDate = product.issued_date || "";
        const formattedDate = issuedDate
          ? new Date(issuedDate).toISOString().split("T")[0]
          : "";
        const matchesSearch =
          facility.toLowerCase().includes(search) ||
          formattedDate.includes(search);
        const matchesFacility =
          !this.filters.facility ||
          facility.toLowerCase() === this.filters.facility.toLowerCase();
        const matchesDate =
          !this.filters.issuedDate || formattedDate === this.filters.issuedDate;
        return matchesSearch && matchesFacility && matchesDate;
      });
    },
    showingText() {
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = start + this.filteredUnitTransfers.length - 1;
      return `Showing ${start}-${end} of ${this.totalCount}`;
    },
  },
  watch: {
    filters: { deep: true, handler: "getUnitTransfers" },
    searchQuery: "getUnitTransfers",
  },
  methods: {
    formatDate(date) {
      const parsedDate = new Date(date);
      if (isNaN(parsedDate.getTime())) {
        console.error("Invalid date:", date);
        return null;
      }
      return parsedDate.toISOString().split("T")[0];
    },
    applyFilters(filters) {
      this.filters = { ...this.filters, ...filters };
      this.currentPage = 1;
    },
    resetFilters() {
      this.filters = {
        facility: "",
        dateIssued: "",
      };
      this.currentPage = 1;
    },
    toggleExpand(unitTransferId) {
      this.expandedTransferId =
        this.expandedTransferId === unitTransferId ? null : unitTransferId;
    },
    async getUnitTransfers() {
      this.loading = true;
      try {
        const queryParams = {
          ...this.filters,
          search_query: this.searchQuery,
          page: this.currentPage,
          per_page: this.perPage,
        };
        const response = await api.getUnitTransfers(queryParams);
        this.products = response.data || response;
        this.currentPage = response.current_page;
        this.totalPages = response.total_pages;
        if (this.currentPage === this.totalPages) {
          this.totalCount = (this.totalPages - 1) * this.perPage + this.products.length;
        } else {
          this.totalCount = this.totalPages * this.perPage;
        }
      } catch (error) {
        console.error("Error fetching unit transfers:", error);
      } finally {
        this.loading = false;
      }
    },
    calculatePageRange() {
      const maxPagesToShow = 5;
      let startPage = Math.max(
        1,
        this.currentPage - Math.floor(maxPagesToShow / 2)
      );
      let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);
      if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getUnitTransfers();
      }
    },
    async previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        await this.getUnitTransfers();
      }
    },
    async nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        await this.getUnitTransfers();
      }
    },
    async convertImageToBase64(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const blob = await response.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        console.warn("convertImageToBase64 failed", e);
        return null;
      }
    },
    async convertSvgToPngBase64(svgUrl) {
      try {
        const response = await fetch(svgUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const svgText = await response.text();
        return new Promise((resolve, reject) => {
          const img = new Image();
          const blob = new Blob([svgText], { type: "image/svg+xml" });
          const url = URL.createObjectURL(blob);
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            resolve(canvas.toDataURL("image/png"));
          };
          img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("Failed to load SVG image"));
          };
          img.src = url;
        });
      } catch (e) {
        console.warn("convertSvgToPngBase64 failed", e);
        return null;
      }
    },
    async previewPDF(unit_transfer_id) {
      this.currentUnitTransferId = unit_transfer_id;
      const doc = new jsPDF();
      this.pdfDoc = doc;

      // Fetch unit transfer data
      const response = await api.getUnitTransfer(unit_transfer_id);
      const unit_transfers = response.data || response;
      const transfers_products = unit_transfers.unit_transfer_products;

      // Load logo
      let image;
      if (this.facility_logo && this.facility_logo.endsWith(".svg")) {
        try {
          image = await this.convertSvgToPngBase64(this.facility_logo);
        } catch (e) {
          console.warn("Failed to load SVG logo", e);
        }
      } else if (this.facility_logo) {
        try {
          image = await this.convertImageToBase64(this.facility_logo);
        } catch (e) {
          console.warn("Failed to load image logo", e);
        }
      }

      if (image) {
        doc.addImage(image, "PNG", 15, 10, 30, 20);
      }

      const pageWidth = doc.internal.pageSize.width;

      // Add facility contact info to top right
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(`${this.facility_details.name}`, pageWidth - 15, 15, { align: "right" });
      doc.text(`${this.facility_details.third_level_devision} Kenya`, pageWidth - 15, 20, { align: "right" });
      doc.text(`${this.facility_details.email}`, pageWidth - 15, 25, { align: "right" });

      // Add date field with the actual date
      doc.setFontSize(11);
      const issueDate = new Date(unit_transfers.issued_date).toLocaleDateString();
      doc.text(`DATE: ${issueDate}`, 15, 50);

      // Add reference header with underline
      doc.setFont("helvetica", "bold");
      doc.text("REF: REQUISITION AND ISSUANCE FORM OF BLOOD AND BLOOD PRODUCTS FROM/TO", 15, 65);
      doc.text("OTHER HEALTH INSTITUTIONS.", 45, 72);
      doc.setFont("helvetica", "normal");

      // Add requisition and issuance fields with values
      doc.text("REQUISITION FROM: _____________________________", 15, 85);
      doc.text(`ISSUANCE TO: ${unit_transfers.facility}`, 15, 95);

      // Add detailed units table (replacing the blood groups table)
      const tableColumns = [
        { header: "#", dataKey: "index" },
        { header: "Serial No.", dataKey: "serial" },
        { header: "Group", dataKey: "group" },
        { header: "Product", dataKey: "product" },
        { header: "Volume", dataKey: "volume" },
        { header: "Days to Expiry", dataKey: "expiry" },
      ];

      const tableData = transfers_products.map((product, index) => ({
        index: index + 1,
        serial: product.product.pint_serial,
        group: product.product.blood_group.name,
        product: product.product.unit_product.name,
        volume: product.product.volume,
        expiry: this.calculateDaysToExpiry(product.product.expiry_date),
      }));

      doc.autoTable({
        startY: 105,
        columns: tableColumns,
        body: tableData,
        theme: "grid",
        styles: { fontSize: 10, cellPadding: 3, lineWidth: 0.5 },
        headStyles: {
          fillColor: [200, 200, 200],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineWidth: 0.5,
        },
        columnStyles: {
          index: { cellWidth: 15 },
          serial: { cellWidth: 40 },
          group: { cellWidth: 30 },
          product: { cellWidth: 30 },
          volume: { cellWidth: 30 },
          expiry: { cellWidth: 35 },
        },
      });

      // Add hemovigilance disclaimer in a light gray box
      const finalY = doc.previousAutoTable.finalY + 15;
      doc.setFillColor(240, 240, 240);
      doc.rect(15, finalY, pageWidth - 30, 40, "F");
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
      doc.text("For hemovigilance report communicate any incidences events.", 17, finalY + 10);
      doc.text(`${this.facility_details.name} does not take any liability that may arise out of use of the blood / blood`, 17, finalY + 20);
      doc.text("products.", 17, finalY + 25);
      doc.text("It's the responsibility of the health institutions carrying out transfusion of the blood", 17, finalY + 35);
      doc.text("products to ensure the safety of the blood/blood products before transfusion.", 17, finalY + 40);

      // Add signature fields with values
      const signatureY = finalY + 55;
      doc.setFontSize(10);
      doc.text("Requested by: ___________________________", 15, signatureY);
      doc.text("Sign: ____________", 100, signatureY);
      doc.text("Date: ________________", 140, signatureY);

      doc.text(`Issued by: ${unit_transfers.user.first_name} ${unit_transfers.user.last_name}`, 15, signatureY + 15);
      doc.text("Sign: ____________", 100, signatureY + 15);
      doc.text(`Date: ${new Date(unit_transfers.issued_date).toLocaleString()}`, 140, signatureY + 15);

      doc.text(`Received by: ${unit_transfers.received_by || "N/A"}`, 15, signatureY + 30);
      doc.text("Sign: ____________", 100, signatureY + 30);
      doc.text(`Date: ${new Date(unit_transfers.received_date).toLocaleString()}`, 140, signatureY + 30);

      // Add footer note
      doc.text(`On behalf of ${this.facility_details.name}.`, 15, signatureY + 50);

      // Add website at the bottom
      doc.setFontSize(8);

      // Generate HTML preview content for browser viewing
      const unitsTableRows = transfers_products
        .map(
          (product, index) => `
          <tr>
            <td style="width: 30px;">${index + 1}</td>
            <td>${product.product.pint_serial}</td>
            <td>${product.product.blood_group.name}</td>
            <td>${product.product.unit_product.name}</td>
            <td>${product.product.volume}</td>
            <td>${this.calculateDaysToExpiry(product.product.expiry_date)}</td>
          </tr>
        `
        )
        .join("");

      const previewHtml = `
        <html>
        <head>
          <title>Blood Issuance Form</title>
          <style>
            @media print {
              @page {
                size: A4;
                margin: 2cm;
              }
            }
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #333;
              margin: 0;
              padding: 20px;
            }
            .header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 30px;
            }
            .logo {
              width: 90px;
            }
            .contact-info {
              text-align: right;
              font-size: 10px;
            }
            .date-field {
              margin: 20px 0;
            }
            .ref-header {
              font-weight: bold;
              margin-bottom: 15px;
            }
            .form-fields {
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: left;
              font-size: 12px;
            }
            th {
              background-color: #f3f4f6;
              font-weight: bold;
            }
            .disclaimer {
              background-color: #f0f0f0;
              padding: 10px;
              margin: 20px 0;
              font-size: 11px;
            }
            .signatures {
              margin-top: 20px;
              font-size: 12px;
            }
            .signature-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 15px;
            }
            .footer {
              margin-top: 30px;
              font-size: 11px;
            }
            .website {
              text-align: center;
              margin-top: 40px;
              font-size: 10px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div>
              <img src="${image}" alt="" class="logo">
            </div>
            <div class="contact-info">
              <p>${this.facility_details.name}</p>
              <p>${this.facility_details.third_level_devision} Kenya</p>
              <p>${this.facility_details.email}</p>
            </div>
          </div>

          <div class="date-field">
            <p>DATE: ${issueDate}</p>
          </div>

          <div class="ref-header">
            <p>REF: REQUISITION AND ISSUANCE FORM OF BLOOD AND BLOOD PRODUCTS FROM/TO</p>
            <p style="margin-left: 30px;">OTHER HEALTH INSTITUTIONS.</p>
          </div>

          <div class="form-fields">
            <p>REQUISITION FROM: _____________________________</p>
            <p>ISSUANCE TO: ${unit_transfers.facility}</p>
          </div>

          <table>
            <thead>
              <tr>
                <th style="width: 30px;">#</th>
                <th>Serial No.</th>
                <th>Group</th>
                <th>Product</th>
                <th>Volume</th>
                <th>Days to Expiry</th>
              </tr>
            </thead>
            <tbody>
              ${unitsTableRows}
            </tbody>
          </table>

          <div class="disclaimer">
            <p>For hemovigilance report communicate any incidences events.</p>
            <p>${this.facility_details.name} does not take any liability that may arise out of use of the blood / blood products.</p>
            <p>It's the responsibility of the health institutions carrying out transfusion of the blood products to ensure the safety of the blood/blood products before transfusion.</p>
          </div>

          <div class="signatures">
            <div class="signature-row">
              <span>Requested by: ______________________________</span>
              <span>Sign: ____________</span>
              <span>Date: ________________</span>
            </div>
            <div class="signature-row">
              <span>Issued by: ${unit_transfers.user.first_name} ${unit_transfers.user.last_name}</span>
              <span>Sign: ____________</span>
              <span>Date: ${new Date(unit_transfers.issued_date).toLocaleString()}</span>
            </div>
            <div class="signature-row">
              <span>Received by: ${unit_transfers.received_by || "N/A"}</span>
              <span>Sign: ____________</span>
              <span>Date: ${new Date(unit_transfers.received_date).toLocaleString()}</span>
            </div>
          </div>

          <div class="footer">
            <p>On behalf of ${this.facility_details.name}.</p>
          </div>
        </body>
        </html>
      `;

      // Create a Blob for preview
      const blob = new Blob([previewHtml], { type: "text/html" });
      this.previewUrl = URL.createObjectURL(blob);
      this.showPreview = true;
    },
    downloadPDF() {
      if (this.pdfDoc) {
        this.pdfDoc.save("blood-issuance-form.pdf");
      }
      this.closePreview();
    },
    printPDF() {
      const printWindow = document.createElement("iframe");
      printWindow.style.position = "absolute";
      printWindow.style.width = "0";
      printWindow.style.height = "0";
      document.body.appendChild(printWindow);

      printWindow.contentDocument.open();
      printWindow.contentDocument.write(`
        <html>
        <head>
          <title>Print Blood Issuance Form</title>
          <style>
            @page {
              size: A4;
              margin: 2cm;
            }
          </style>
        </head>
        <body>
          <iframe src="${this.previewUrl}" style="width:100%;height:100vh;"></iframe>
        </body>
        </html>
      `);
      printWindow.contentDocument.close();

      printWindow.contentWindow.onload = function () {
        printWindow.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(printWindow);
        }, 1000);
      };
      this.closePreview();
    },
    closePreview() {
      this.showPreview = false;
      this.previewUrl = null;
      this.pdfDoc = null;
      this.currentUnitTransferId = null;
    },
    calculateDaysToExpiry(expiryDate) {
      const expiry = new Date(expiryDate);
      const today = new Date();
      const diffTime = Math.abs(expiry - today);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return `${diffDays} days`;
    },
  },
};
</script>

<style lang="css" scoped>
/* Add any additional styles if needed */
</style>